export { default as TrackedDetails } from './tracked-details';
